<template>
  <p-models v-if="$hasPermission('administration.read')" />
  <p-not-found v-else />
</template>

<script>
import Models from '@/components/llm-configurations/ModelsConfigurations.vue';
import NotFound from '@/components/NotFound.vue';

export default {
  components: {
    'p-models': Models,
    'p-not-found': NotFound
  }
};
</script>
